export const COMPONENT_NAME = "shared-verification";
